// extracted by mini-css-extract-plugin
module.exports = {"heading":"incentive-screen_heading__dArJ2","title":"incentive-screen_title__1YdIb"};